<template>
    <div class="c-case-product">
        <LayoutContent>
            <div class="c-case-inner-box">
                <TemplateHeader>
                    <TitleText>
                        <template v-slot:left>{{ $t("main:丰富的游戏语音") }}</template>
                        <template v-slot:import>{{ $t("main:功能") }}</template>
                    </TitleText>
                </TemplateHeader>

                <div class="c-case-tabs">
                    <div class="c-tabs-header-box">
                        <!-- {is-active} -->
                        <div :class="['tabs-header-item', { 'is-active': tab === 0 }]" @mouseenter="tab = 0">
                            <span class="item-text">{{ $t("main:实时语音") }}</span>
                        </div>
                        <div :class="['tabs-header-item', { 'is-active': tab === 1 }]" @mouseenter="tab = 1">
                            <span class="item-text"
                                >{{ $t("main:语音消息") }}<br />
                                &amp; <br />{{ $t("main:语音转文字") }}
                            </span>
                        </div>
                        <div :class="['tabs-header-item', { 'is-active': tab === 2 }]" @mouseenter="tab = 2">
                            <span class="item-text">{{ $t("main:文明语音") }} </span>
                        </div>
                        <div :class="['tabs-header-item', { 'is-active': tab === 3 }]" @mouseenter="tab = 3">
                            <span class="item-text">{{ $t("main:语音同传") }} </span>
                        </div>
                    </div>
                    <div class="c-tabs-content-box">
                        <!-- 实时语音 start -->
                        <div class="cd-tabs-content-inner" v-show="tab === 0">
                            <div class="inner-content">
                                <div class="cd-inner-item">
                                    <p class="inner-title">{{ $t("main:功能介绍") }}</p>
                                    <div class="inner-detail">
                                        <p class="text-detail">- {{ $t("main:小队语音：通过GVoice语音组件，提供小队语音接口，支持500人的语音房间。方便玩家实时互动，开黑打团。") }}</p>
                                        <p class="text-detail">- {{ $t("main:范围语音：针对玩家的坐标换算在同一语音房间，方便在同一区域的玩家可以互相交流。为游戏提供更多玩法可能性。") }}</p>
                                        <p class="text-detail">- {{ $t("main:3D语音：根据玩家的距离远近提供一定的语音音量衰减功能，同时提供3D立体声音方位享受。") }}</p>
                                        <p class="text-detail">
                                            - {{ $t("main:国战语音：提供万人团队指挥系统，具有发言权限的玩家才可以发言，保证总指挥和各分指挥调度流畅。同时支持背景音乐播放，提升玩家游戏热情。") }}
                                        </p>
                                    </div>
                                </div>
                                <div class="cd-inner-item">
                                    <p class="inner-title">{{ $t("main:接入项目") }}</p>
                                    <div class="c-inner-projects-box">
                                        <ul class="cd-inner-projects-list">
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-01.png" />
                                            </li>
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-02.png" />
                                            </li>
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-03.png" />
                                            </li>
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-04.png" />
                                            </li>
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-05.png" />
                                            </li>
                                        </ul>
                                        <span class="cd-projects-button">
                                            <a href="/case"><i class="gvfont gvfont-arrow-right"></i></a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="inner-side">
                                <div class="inner-img">
                                    <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/product/img-case-gvoice-01.png" />
                                </div>
                            </div>
                        </div>
                        <!-- 实时语音 end -->
                        <!-- 语音消息 &amp; 语音转文字 start -->
                        <div class="cd-tabs-content-inner" v-show="tab === 1">
                            <div class="inner-content">
                                <div class="cd-inner-item">
                                    <p class="inner-title">{{ $t("main:功能介绍") }}</p>
                                    <div class="inner-detail">
                                        <p class="text-detail">
                                            {{ $t("main:常见于游戏大厅系统，支持玩家录制一段语音消息发送给其他玩家。同时GVoice提供语音消息转文字功能，方便玩家以文本形式接收并阅读语音消息。") }}
                                        </p>
                                    </div>
                                </div>
                                <div class="cd-inner-item">
                                    <p class="inner-title">{{ $t("main:接入项目") }}</p>
                                    <div class="c-inner-projects-box">
                                        <ul class="cd-inner-projects-list">
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-01.png" />
                                            </li>
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-02.png" />
                                            </li>
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-03.png" />
                                            </li>
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-04.png" />
                                            </li>
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-05.png" />
                                            </li>
                                        </ul>
                                        <span class="cd-projects-button">
                                            <a href="/case"><i class="gvfont gvfont-arrow-right"></i></a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="inner-side">
                                <div class="inner-img">
                                    <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/product/img-case-gvoice-02.png" />
                                </div>
                            </div>
                        </div>
                        <!-- 语音消息 &amp; 语音转文字 end -->
                        <!-- 文明语音 start -->
                        <div class="cd-tabs-content-inner" v-show="tab === 2">
                            <div class="inner-content">
                                <div class="cd-inner-item">
                                    <p class="inner-title">{{ $t("main:功能介绍") }}</p>
                                    <div class="inner-detail">
                                        <p class="text-detail">- {{ $t("main:提供一键举报功能，支持玩家在游戏中对于辱骂、色情、反动政治等违法行为进行举报，由后台安全审核后下发处罚。") }}</p>
                                        <p class="text-detail">- {{ $t("main:提供订阅审核功能，对于被举报的玩家本局游戏持续进行安全审核，支持对于游戏实时语音的全量审核。") }}</p>
                                        <p class="text-detail">- {{ $t("main:提供语音消息的安全审核服务，打击违法违规的语音消息。") }}</p>
                                    </div>
                                </div>
                                <div class="cd-inner-item">
                                    <p class="inner-title">{{ $t("main:接入项目") }}</p>
                                    <div class="c-inner-projects-box">
                                        <ul class="cd-inner-projects-list">
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-01.png" />
                                            </li>
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-02.png" />
                                            </li>
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-03.png" />
                                            </li>
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-04.png" />
                                            </li>
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-05.png" />
                                            </li>
                                        </ul>
                                        <span class="cd-projects-button">
                                            <a href="/case"><i class="gvfont gvfont-arrow-right"></i></a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="inner-side">
                                <div class="inner-img">
                                    <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/product/img-case-gvoice-03.png" />
                                </div>
                            </div>
                        </div>
                        <!-- 文明语音 end -->
                        <!-- 语音同传 start -->
                        <div class="cd-tabs-content-inner" v-show="tab === 3">
                            <div class="inner-content">
                                <div class="cd-inner-item">
                                    <p class="inner-title">{{ $t("main:功能介绍") }}</p>
                                    <div class="inner-detail">
                                        <p class="text-detail">
                                            {{
                                                $t(
                                                    "main:面对与海外玩家组队游戏时的语言交流问题，GVoice提供将语音消息识别并翻译成玩家本国文字的解决方案。同时小队语音还支持实时语音同声传译，对接收到的实时语音进行翻译并以指定语言的声音进行播放。"
                                                )
                                            }}
                                        </p>
                                    </div>
                                </div>
                                <div class="cd-inner-item">
                                    <p class="inner-title">{{ $t("main:接入项目") }}</p>
                                    <div class="c-inner-projects-box">
                                        <ul class="cd-inner-projects-list">
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-01.png" />
                                            </li>
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-02.png" />
                                            </li>
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-03.png" />
                                            </li>
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-04.png" />
                                            </li>
                                            <li class="projects-list">
                                                <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/global/logo-05.png" />
                                            </li>
                                        </ul>
                                        <span class="cd-projects-button">
                                            <a href="/case"><i class="gvfont gvfont-arrow-right"></i></a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="inner-side">
                                <div class="inner-img">
                                    <img src="https://gcloudweb-1256818929.cos.ap-shanghai.myqcloud.com/static/images/GVoice-Ex/product/img-case-gvoice-04.png" />
                                </div>
                            </div>
                        </div>
                        <!-- 语音同传 end -->
                    </div>
                </div>
            </div>
        </LayoutContent>
    </div>
</template>

<script>
import LayoutContent from "@/components/UI/LayoutContent.vue";
import TitleText from "@/components/UI/TitleText.vue";
import TemplateHeader from "@/components/UI/TemplateHeader.vue";
export default {
    name: "CaseProduct",
    components: { LayoutContent, TitleText, TemplateHeader },
    data() {
        return {
            tab: 0, // 当前选中的tab
        };
    },
};
</script>

<style scoped lang="less">
@import "/web/src/assets/css/theme.less";
.c-case-tabs {
    margin-top: 32px;
}
.c-case-product {
    padding: 0 24px;
}
.c-case-inner-box {
    min-height: 700px;
}
.c-tabs-header-box {
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #b4b6b7;
    .tabs-header-item {
        flex: 1;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        padding: 16px 24px;
        cursor: default;
        &:hover {
            .item-text {
                color: @primary-color;
            }
        }
        &.is-active {
            position: relative;
            &:after {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                bottom: -1px;
                height: 2px;
                background: @primary-color;
            }
            .item-text {
                color: @primary-color;
            }
        }
        & + .tabs-header-item {
            margin-left: 8px;
        }
        .item-text {
            font-size: 22px;
            color: #666666;
            br {
                display: none;
            }
        }
    }
}
.c-tabs-content-box {
    padding: 64px 0;
}
.cd-tabs-content-inner {
    display: flex;
    align-items: center;
    .inner-content {
        flex: 1;
        margin-top: 16px;
        & + .inner-side {
            margin-left: 80px;
        }
    }
    .inner-side {
        .inner-img {
            width: 100%;
            img {
                width: 100%;
                max-width: 580px;
            }
        }
    }
}
.cd-inner-item {
    & + .cd-inner-item {
        margin-top: 48px;
    }
    .inner-title {
        font-size: 20px;
        color: #222;
        font-weight: bold;
        & + .inner-detail {
            margin-top: 16px;
        }
        & + .c-inner-projects-box {
            margin-top: 24px;
        }
    }
    .inner-detail {
        font-size: 16px;
        color: #666666;
        line-height: 26px;
        .text-detail {
            & + .text-detail {
                margin-top: 8px;
            }
        }
    }
}

.cd-inner-projects-list {
    display: flex;
    align-items: center;
    .projects-list {
        & + .projects-list {
            margin-left: 38px;
        }
        img {
            width: 60px;
            height: 60px;
        }
    }
}
.cd-projects-button {
    cursor: pointer;
    &:hover {
        .gvfont {
            color: @primary-color;
        }
    }
    .gvfont {
        font-size: 32px;
        color: #666666;
    }
}

.c-inner-projects-box {
    display: flex;
    align-items: center;
    .cd-inner-projects-list {
        & + .cd-projects-button {
            margin-left: 32px;
        }
    }
}
@media only screen and (max-width: 1200px) {
    .c-case-inner-box {
        min-height: unset;
    }
    .c-tabs-header-box {
        .tabs-header-item {
            padding: 8px;
            .item-text {
                font-size: 18px;
            }
        }
    }
    .c-tabs-content-box {
        padding: 32px 0 56px;
    }
    .cd-inner-item {
        & + .cd-inner-item {
            margin-top: 24px;
        }
        .inner-title {
            font-size: 16px;
        }
        .inner-detail {
            font-size: 14px;
        }
    }
    .cd-inner-projects-list {
        .projects-list {
            & + .projects-list {
                margin-left: 24px;
            }
            img {
                width: 48px;
                height: 48px;
            }
        }
    }
    .cd-projects-button {
        .gvfont {
            font-size: 24px;
        }
    }
    .cd-tabs-content-inner {
        .inner-content {
            margin-top: 24px;
            & + .inner-side {
                margin-left: 24px;
            }
        }
        .inner-side {
            .inner-img {
                img {
                    max-width: 480px;
                }
            }
        }
    }
}
@media only screen and (max-width: 995px) {
    .c-case-tabs {
        display: flex;
    }
    .c-tabs-header-box {
        flex-direction: column;
        align-items: flex-end;
        justify-content: flex-start;
        border-bottom: none;
        border-right: 1px solid #eeeff1;
        .tabs-header-item {
            flex: unset;
            padding-right: 16px;
            &.is-active {
                &::after {
                    left: auto;
                    right: -1px;
                    top: 8px;
                    bottom: 6px;
                    margin: auto;
                    width: 2px;
                    height: auto;
                }
            }
            & + .tabs-header-item {
                margin-left: 0;
                margin-top: 8px;
            }
            .item-text {
                font-size: 16px;
                text-align: right;
                white-space: nowrap;
                br {
                    display: block;
                }
            }
        }
    }
    .c-tabs-content-box {
        padding: 24px 24px 40px;
    }
    .cd-inner-item {
        .inner-title {
            font-size: 16px;
            & + .inner-detail {
                margin-top: 8px;
            }
            & + .c-inner-projects-box {
                margin-top: 16px;
            }
        }
        .inner-detail {
            font-size: 14px;
            line-height: 1.6;
        }
    }
    .cd-inner-projects-list {
        .projects-list {
            & + .projects-list {
                margin-left: 24px;
            }
            img {
                width: 48px;
                height: 48px;
            }
        }
    }
    .cd-projects-button {
        .gvfont {
            font-size: 24px;
        }
    }
    .cd-tabs-content-inner {
        flex-direction: column-reverse;
        .inner-content {
            & + .inner-side {
                margin-left: 0;
            }
        }
        .inner-side {
            width: 100%;
            .inner-img {
                display: flex;
                justify-content: center;
                width: 100%;
                img {
                    width: 100%;
                    max-width: 480px;
                }
            }
        }
    }
}
@media only screen and (max-width: 576px) {
    .c-inner-projects-box {
        .cd-inner-projects-list {
            flex: 1;
            & + .cd-projects-button {
                margin-left: 8px;
            }
            .projects-list {
                flex: 1;
                & + .projects-list {
                    margin-left: 16px;
                }
                img {
                    width: 100%;
                    height: auto;
                }
            }
        }
    }
    .c-tabs-header-box {
        .tabs-header-item {
            .item-text {
                font-size: 12px;
            }
        }
    }
    .c-tabs-content-box {
        padding: 0 16px 32px;
    }
}
@media only screen and (max-width: 480px) {
    .c-inner-projects-box {
        .cd-inner-projects-list {
            .projects-list {
                & + .projects-list {
                    margin-left: 8px;
                }
            }
        }
    }
}
</style>
